"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _StoryAction2 = require("./StoryAction");

var _StoryAction3 = _interopRequireDefault(_StoryAction2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var _class = function (_StoryAction) {
  _inherits(_class, _StoryAction);

  function _class(_ref) {
    var game = _ref.game,
        data = _ref.data;

    _classCallCheck(this, _class);

    var _this = _possibleConstructorReturn(this, (_class.__proto__ || Object.getPrototypeOf(_class)).call(this, game, data));

    _this.password = _this.data.password;

    _this.choices = [
    //      "Lentilsoy",
    "I<3Aliens", "Alienluvr69", "AbductMePlz"];

    _this.unlockers = data.unlockers;

    var gameState = _this.game.state.states[_this.game.state.current];
    _this.desktop = gameState.desktop;
    _this.terminal = gameState.desktop.terminal;
    _this.storyEngine = gameState.storyEngine;

    _this.choiceChar = '>';
    return _this;
  }

  _createClass(_class, [{
    key: "onEnable",
    value: function onEnable() {
      _get(_class.prototype.__proto__ || Object.getPrototypeOf(_class.prototype), "onEnable", this).call(this);

      Object.keys(this.unlockers).forEach(function (unlocker) {
        var node = this.storyEngine.getNode(unlocker);
        node.onCompleteSignal.addOnce(this.onUnlockerNodeComplete, this);
      }, this);

      this.showPrompt();
    }
  }, {
    key: "onComplete",
    value: function onComplete() {
      this.desktop.unlock();

      this.removeClickListeners();

      Object.keys(this.unlockers).forEach(function (unlocker) {
        var node = this.storyEngine.getNode(unlocker);
        node.onCompleteSignal.remove(this.onUnlockerNodeComplete, this);
      }, this);

      _get(_class.prototype.__proto__ || Object.getPrototypeOf(_class.prototype), "onComplete", this).call(this);
    }
  }, {
    key: "showPrompt",
    value: function showPrompt() {
      this.terminal.onBufferEmptySignal.addOnce(this.addClickListeners, this);

      this.terminal.addText("Enter password:\n\n");

      this.choices.forEach(function (choice) {
        this.terminal.addText(this.choiceChar + " " + choice + "\n\n");
      }, this);

      this.terminal.addText("\n");
    }
  }, {
    key: "addClickListeners",
    value: function addClickListeners() {
      var currentChoice = 0;

      this.terminal.lines.forEach(function (line) {
        if (line.text[0] == this.choiceChar) {
          currentChoice++;
        }

        if (currentChoice > 0 && line.text != '') {
          var choiceText = line.text.substring(2, line.text.length);

          line.inputEnabled = true;
          line.input.useHandCursor = true;
          line.events.onInputDown.addOnce(this.onChoiceClick, this, 0, choiceText);
        }
      }, this);
    }
  }, {
    key: "removeClickListeners",
    value: function removeClickListeners() {
      this.terminal.lines.forEach(function (line) {
        line.events.onInputDown.removeAll();
        line.inputEnabled = false;
      }, this);
    }
  }, {
    key: "onChoiceClick",
    value: function onChoiceClick(choiceText, pointer, password) {
      if (password == this.password) {
        game.sound.play('right_password');
        this.onComplete();
      } else {
        game.sound.play('wrong_password');
        this.removeClickListeners();
        this.showPrompt();
      }
    }
  }, {
    key: "onUnlockerNodeComplete",
    value: function onUnlockerNodeComplete(node) {
      var index = Object.keys(this.unlockers).indexOf(node.id);
      this.choices[index] = this.unlockers[node.id];

      this.removeClickListeners();
      this.showPrompt();
    }
  }]);

  return _class;
}(_StoryAction3.default);

exports.default = _class;


//////////////////
// WEBPACK FOOTER
// ./src/story/PasswordPromptAction.js
// module id = 354
// module chunks = 0